<template>
    <TsRow isMultiline>
        <TsColumn class="lg:is-4 is-12" v-for="item in data" :key="item.id">
            <TsCard appendClass="p-2 border-none bg-[#F3F4F6] rounded-full">
                <TsMedia appendClass="">
                    <TsMediaStart appendClass="my-auto">
                        <div class=" rounded-full bg-white max-w-max p-3">
                            <TsImage v-if="item && item.image" class="flex mx-auto" :src="item.image" :alt="item?.alt"  width="35" height="35" loading="lazy"/>
                        </div>
                    </TsMediaStart>
                    <TsMediaContent>
                        <TsTypography appendClass="font-semibold text-black mb-0">{{ item.heading }}</TsTypography>
                        <TsTypography as="h5" appendClass="mb-0 mt-0 text-[#6B7280] font-medium">{{ item.description }}
                        </TsTypography>
                    </TsMediaContent>
                </TsMedia>
            </TsCard>
        </TsColumn>
    </TsRow>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);
const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);
const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

type Props = {
    data: object[]
};

const props = withDefaults(defineProps<Props>(), {
    data: [
        {
            id: 1,
            image: '/images/JoinUs(1).png',
            heading: 'Dynamic Company',
            description: 'Join a company that\'s thriving, evolving, and expanding into new markets.'
        },
        {
            id: 2,
            image: '/images/JoinUs(2).png',
            heading: 'Dynamic Company',
            description: 'Join a company that\'s thriving, evolving, and expanding into new markets.'
        },
        {
            id: 3,
            image: '/images/JoinUs(3).png',
            heading: 'Dynamic Company',
            description: 'Join a company that\'s thriving, evolving, and expanding into new markets.'
        },
    ]
});
</script>
